<template>
  <div>
    <full-video :showKeywords="true" v-if="issues.length" v-bind:issue="issues[0]"></full-video>
    <div class="videos-list">
      <div class="video-item" v-for="(issue, index) in issues" :key="issue.id" v-if="index>0 && index<7">
        <condensed-video v-bind:issue="issue" :showKeywords="true"></condensed-video>
      </div>
    </div>
  </div>
</template>

<script>
  import FullVideo from '@/components/shared/FullVideoComponent'
  import CondensedVideo from '@/components/shared/CondensedVideoComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    components: {
      FullVideo,
      CondensedVideo
    },
    name: 'author-interviews',
    mixins: [ UtilityMixin ],
    data () {
      return {
        issues: []
      }
    },
    created () {
      this.issues = this.getStaticPath('mocks/video-list.json').videos
    },
    mounted () {
      this.$parent.sortBar = {
        title: 'Interviews with Outstanding Authors',
        count: this.issues.length + ' Videos'
      }
    },
    beforeDestroy () {
      this.$parent.sortBar = false
    }
  }
</script>


<style lang="scss" scoped>
  .videos-list {
    border-top: 1px solid $devider;
  }
  .video-item {
    float: left;
    width: calc(50% - 0.5px);
    padding-top: $spacing-large;
    padding-bottom: $spacing-large;
    margin-top: $spacing-large;
    margin-bottom: $spacing-large;
  &:nth-child(odd) {
     padding-right: $spacing-large;
     border-right: 1px solid $devider;
   }
  &:nth-child(even) {
     padding-left: $spacing-large;
  &:after {
     content: '';
     display: block;
     border-bottom: 1px solid $devider;
     position: absolute;
     width: calc(100% - 30px);
     height: $spacing-large;
     left: 0;
     margin: $spacing-large 15px;
   }
  &:last-child:after {
     border-bottom: none;
   }
  }
  }

</style>



// WEBPACK FOOTER //
// AuthorInterviewsPage.vue?445a12b4